<template>
  <OnboardingModalContent :title="$t('onboarding_give_back_subtitle')">
    <p class="tw-text-center tw-mt-10">
      {{ $t('onboarding_give_back_message_1') }}
    </p>
    <div class="tw-grid tw-grid-rows-2 tw-gap-3 tw-w-32 tw-mx-auto tw-my-10">
      <Button small @click="$emit('next')">{{ $t('onboarding_yes') }}</Button>
      <Button small inverted @click="$emit('next')">{{
        $t('onboarding_not_now')
      }}</Button>
    </div>

    <template #bottom>
      <p class="tw-text-center">
        {{ $t('onboarding_give_back_message_2') }}
      </p>
    </template>
  </OnboardingModalContent>
</template>

<script>
import OnboardingModalContent from './OnboardingModalContent'
import Button from '@/components/onboarding/Button'

export default {
  components: {
    Button,
    OnboardingModalContent,
  },
  data() {
    return { success: false }
  },
}
</script>

<style scoped></style>
